import { render } from "./IdenityDialog.vue?vue&type=template&id=6a71a49a"
import script from "./IdenityDialog.vue?vue&type=script&lang=js"
export * from "./IdenityDialog.vue?vue&type=script&lang=js"

import "./IdenityDialog.vue?vue&type=style&index=0&id=6a71a49a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__